export default "__VITE_ASSET__DZvrviIw__"